import { apiGet, apiPost } from "../../utils"

// News APIs
export function getNewsAPI() {
    return apiGet('/api/getNews')
}

export function addNewsAPI(data) {
    return apiPost('/api/addNews', data)
}

// Video Links APIs
export function getVideoLinksAPI() {
    return apiGet('/api/getVideoLinks')
}

export function updateHomepageVideoAPI(data) {
    return apiPost('/api/updateHomepageVideo', data)
}
